var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "modal" } }, [
    _c("div", { staticClass: "modal-mask" }, [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c(
          "div",
          {
            staticClass: "modal-container modal-container-80",
            on: { click: _vm.dontClose },
          },
          [
            _c(
              "div",
              {
                staticClass: "modal-body m-0",
                staticStyle: { "overflow-y": "auto" },
                style: { maxHeight: _vm.getMaxHeightClient() + "px" },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: { margin: "0px 20px 0px 20px" },
                    attrs: { slot: "formcontent" },
                    slot: "formcontent",
                  },
                  [
                    _c(
                      "b-row",
                      { staticClass: "panel-heading" },
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "formTitleBlock",
                            attrs: { cols: "12" },
                          },
                          [
                            _c(
                              "h4",
                              {
                                staticClass: "content-block labelAccordionForm",
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-light fa-file-code mr-2",
                                  staticStyle: { "font-size": "20px" },
                                }),
                                _vm._v(
                                  "\n                  " +
                                    _vm._s("Document") +
                                    "\n                "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", [
                          _c("iframe", {
                            attrs: {
                              src: _vm.data.src,
                              height: (80 * _vm.maxHeight) / 100 + "px",
                              width: "100%",
                            },
                          }),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "p-0 m-0",
                    attrs: { lg: "2", sm: "3", cols: "6" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.downloadFile()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.download")))]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }